import { CSSObject } from '@mui/material'

const globalStyles: CSSObject = {
  '.react-icon *': {
    vectorEffect: 'non-scaling-stroke',
  },
  a: {
    color: 'inherit',
  },
}

export default globalStyles
